import { render, staticRenderFns } from "./temhead8.vue?vue&type=template&id=70887f22&scoped=true"
import script from "./temhead8.vue?vue&type=script&lang=js"
export * from "./temhead8.vue?vue&type=script&lang=js"
import style0 from "./temhead8.vue?vue&type=style&index=0&id=70887f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70887f22",
  null
  
)

export default component.exports